import { Navigate, Route, Routes } from 'react-router-dom'
import { Filter } from '../Modules/Filter/Filter'
import { GrafoPage } from '../Modules/GrafoPage/GrafoPage'
import { Home } from '../Modules/Home/Home'
import { Metodologia } from '../Modules/metodologia/metodologia'

export const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/grafo" element={<GrafoPage />} />
      <Route path="/filters" element={<Filter />} />
      <Route path="/metodologia" element={<Metodologia />} />
      <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
  )
}
